define("shared/helpers/time-ago", ["exports", "@ember/component/helper", "@ember/template", "moment"], function (_exports, _helper, _template, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/template",0,"moment"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /** Converts a date time to time-ago format.
   *
   * @method time-ago
   * @param {String|Number} [dateTime] Unix timestamp, date string or individual date and time component values
   *
   * @return {String} The span of date time passed relative to the user's current date time.
   */
  class timeAgo extends _helper.default {
    compute(dateTime) {
      let normalizedDate = dateTime;
      if (typeof dateTime === 'string' && isNaN(dateTime)) {
        normalizedDate = new Date(dateTime);
      }
      if (dateTime > 10000000000) {
        //due to UTC date calculation for line-graph
        normalizedDate = dateTime / 1000;
      }
      const parsedDate = _moment.default.unix(normalizedDate);
      return new _template.htmlSafe('<time datetime=' + normalizedDate + '>' + parsedDate.fromNow() + '</time>');
    }
  }
  _exports.default = timeAgo;
});